export const num2name = {
    0: "ERROR_UNSPECIFIED",
    1: "INVALID_CONFIG",
};
export const name2num = {
    ERROR_UNSPECIFIED: 0,
    INVALID_CONFIG: 1,
};
